"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Search = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../../../contexts");
var _models = require("../../../../models");
var _hooks = require("../../hooks");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Search = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    clearSearch,
    search
  } = (0, _contexts.usePickupPoints)();
  const placeholder = (0, _hooks.useSearchPlaceholder)();
  const [searchTerm, setSearchTerm] = (0, _react.useState)('');
  const ref = (0, _react.useRef)(null);
  const inputRef = (0, _react.useRef)(null);
  const onSearch = (0, _react.useCallback)(({
    target: {
      value: newSearchTerm
    }
  }) => {
    setSearchTerm(newSearchTerm);
    // triggers search when the search term is at least 3 characters long
    if (newSearchTerm.trim().length > 2) {
      search(newSearchTerm.trim());
      // triggers to clear search and show pickup points for previous map position
    } else {
      search(undefined);
    }
  }, [search]);
  // Clears the search and keeps the input focused
  const onClear = (0, _react.useCallback)(event => {
    event.preventDefault();
    setSearchTerm('');
    clearSearch();
  }, [clearSearch]);
  // Do not expand drawer when clicking on the search input
  const onSearchClick = (0, _react.useCallback)(event => {
    setTimeout(() => {
      window.scrollTo({
        top: 0
      });
    }, 350);
  }, []);
  const InputProps = (0, _react.useMemo)(() => ({
    startAdornment: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MapPin, {}),
    endAdornment: searchTerm ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ClearButton, {
      onClick: onClear,
      onMouseDown: onClear,
      onTouchStart: onClear
    }) : null
  }), [onClear, searchTerm]);
  const onBlur = (0, _react.useCallback)(() => {
    inputRef.current?.blur();
  }, []);
  const onKeyDown = (0, _react.useCallback)(event => {
    if (event.key === 'Enter') {
      onBlur();
    }
  }, [onBlur]);
  // lose focus on touch outside search input
  (0, _react.useEffect)(() => {
    const handleTouchStart = event => {
      if (!ref.current?.contains(event.target)) {
        onBlur();
      }
    };
    document.addEventListener('touchstart', handleTouchStart);
    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
    };
  }, [onBlur]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_models.TestId.SelectPickupPointDialogSearch),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SearchInput, {
      ref: ref,
      variant: "filled",
      color: "primary",
      InputProps: InputProps,
      inputRef: inputRef,
      placeholder: placeholder,
      value: searchTerm,
      onChange: onSearch,
      onClick: onSearchClick,
      onTouchStart: onSearchClick,
      onTouchMove: onBlur,
      onKeyDown: onKeyDown
    })
  });
};
exports.Search = Search;